<div class="page-title animatedBackground">
    
    <div class="container">
        <h3>Career</h3>
        <ul>
            <li><a router="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Career</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="features-area ptb-100">
    <div class="container">
     
        
        <div class="row  align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="analysis-text">
                    <h3>We're looking for brilliant minds to join our top-notch team and make it even better. Are you ready?</h3>
                  
                </div>
            </div>
            
            <div class="col-lg-6 col-md-6">
                <div class="img mb-0">
                    <img  style="border-radius: 20px;   box-shadow: 5px 10px #f2f2f2;
                    " src="assets/img/career.png" alt="image">
                </div>
            </div>
        </div>
        
 </div>
</section>
<section class="analysis-area ptb-100 bg-fbf9f8">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-12">
                <div class="analysis-form">
                    <h3>Join Us</h3>
                    <form enctype="multipart/form-data">
                        <div class="form-group">
                            <input type="text" [(ngModel)]="name" [ngModelOptions]="{standalone: true}" placeholder="Name*" class="form-control">
                        </div>
                        <div class="form-group">
                            <input type="email" [(ngModel)]="email" [ngModelOptions]="{standalone: true}" placeholder="Email*" class="form-control">
                        </div>
                        <div class="form-group">
                            <input type="text" [(ngModel)]="phone" [ngModelOptions]="{standalone: true}" placeholder="Phone*" class="form-control">
                        </div>
                        <div class="form-group">
                            <input type="text" [(ngModel)]="appliedfor" [ngModelOptions]="{standalone: true}" placeholder="Applied For*" class="form-control">
                        </div>
                        <div class="form-group">
                            <input type="file" (change)="uploadFile($event.target.files)" [(ngModel)]="cv" [ngModelOptions]="{standalone: true}" placeholder="CV*" class="form-control">
                        </div>
                        <button type="button" (click)="onSubmit()" class="btn btn-primary">Apply</button>
                    </form>
                </div>
            </div>
            
            <div class="col-lg-7 col-md-12">
                <div class="analysis-text">
                 
                    <h3>WHY JOIN OSIT? </h3>
                    <h5>Join us as we help you build your career, it’s not just a job.<br>&nbsp;</h5>
                    <p>We bring the revolutionary power of modern-day technologies to businesses and people worldwide. With top 1% industry talent, innovators, and forward-looking people, OSIT is a people’s first company known for its talent as much as it is for its solutions. Experience the feel-good factor and the true value of work-life balance by working with us.</p>
              
                </div>
            </div>
        </div>
    </div>
</section>